import { css } from '@emotion/core'
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'
import { radiantBlue, black, gray, MQ } from '@css/constants'

export const customDayPickerStyles = css`
  .DayPickerInput {
    width: 100%;
  }

  .DayPicker-Day {
    padding: 10px;

    ${MQ.SMALL_SCREENS} {
      padding: 6px;
    }
  }

  .DayPicker-Day:not(.DayPicker-Day--disabled) {
    ${FontNormal(500)};
    ${fontSize(16)};
    box-sizing: border-box;
    border-radius: 5px;
    color: ${black};
    outline: ${radiantBlue} auto 1px;
    outline-offset: -2px;
  }

  .DayPicker-Day.DayPicker-Day--outside {
    outline: none;
  }

  .DayPicker-Day--disabled {
    ${FontNormal(500)};
    ${fontSize(16)};
    color: ${gray};
  }

  .DayPicker-Caption {
    & > * {
      ${FontNormal(500)};
      ${fontSize(16)};
      text-align: center;
      text-transform: uppercase;
    }
  }

  .DayPicker-NavButton--prev {
    left: 10px;
  }

  .DayPicker-NavButton--next {
    right: 10px;
  }

  .DayPicker-Weekday {
    ${FontNormal(500)};
    ${fontSize(16)};
    color: ${radiantBlue};
  }

  .DayPickerInput-Overlay {
    border: 1px solid ${gray};
    box-shadow: 0px 4px 12px rgba(26, 28, 31, 0.15);
    border-radius: 5px;
  }
`
